export default class PropertyTypesConstants {
  static APARTMENT_TYPE = 2;

  static BUNGALOW_TYPE = 3;
}
